module.exports = __webpack_public_path__ + "static/media/Gilroy-Bold.889a4b5c.ttf";